/* eslint-disable */
const globalCanvas = null
const globalWaterMark = null

// watermark 样式
let style = `
display: block;
overflow: hidden;
position: absolute;
left: 0;
top: 0;
width: 100%;
height: 100%;
background-repeat: repeat;
pointer-events: none;`

const getDataUrl = (text) => {
  const rotate = 20;
  const canvas = globalCanvas || document.createElement("canvas");
  const ctx = canvas.getContext("2d"); // 获取画布上下文
  canvas.width = 198 // 设置宽度
  //canvas.height = 20 + text.length * 15 // 高度
  canvas.height = 148.5
  ctx.rotate((rotate * Math.PI) / 180);
  ctx.translate(118.8, 34);
  ctx.font = "26px Regular";
  ctx.fillStyle = "rgba(0, 0, 0, 0.1)";
  ctx.textAlign = "left";
  ctx.textBaseline = "middle";
  let x1 = (text.PubRealName.length / 2) * -26
  let x2 = (text.PubPhone.length / 2) * -15.2
  ctx.fillText(text.PubRealName, x1, -13);
  ctx.fillText(text.PubPhone, x2, 13);
  return canvas.toDataURL("image/png");
};

const setWaterMark = (el, binding = {}) => {
  const parentElement = el;
  // 获取对应的 canvas 画布相关的 base64 url
  const waterMark = globalWaterMark || document.createElement("div");
  let childrenNodes = parentElement.querySelector('.water-mark')
  if (binding && !childrenNodes) {
    if (binding === '  ') {
      binding = '水印'
    }
    const url = getDataUrl(binding);
    // 创建 waterMark 父元素
    waterMark.className = `water-mark`; // 方便自定义展示结果
    style = `${style}background-image: url(${url});`;
    waterMark.setAttribute("style", style);

    // 将对应图片的父容器作为定位元素
    parentElement.setAttribute("style", "position: relative;");

    // 将图片元素移动到 waterMark 中
    parentElement.appendChild(waterMark);
  } else if (!binding && childrenNodes) {
    if (childrenNodes) {
      childrenNodes.remove()
    }
  }
};

// 监听 DOM 变化
const createObserver = (el, binding) => {
  const waterMarkEl = el.querySelector(".water-mark");

  const observer = new MutationObserver((mutationsList) => {
    if (mutationsList.length) {
      const { removedNodes, type, target } = mutationsList[0];
      const currStyle = waterMarkEl.getAttribute("style");

      // 证明被删除了
      if (removedNodes[0] === waterMarkEl) {
        observer.disconnect();
        init(el, binding);
      } else if (
        type === "attributes" &&
        target === waterMarkEl &&
        currStyle !== style
      ) {
        waterMarkEl.setAttribute("style", style);
      }
    }
  });

  observer.observe(el, {
    childList: true,
    attributes: true,
    subtree: true,
  });
};

// 初始化
const init = (el, binding = {}) => {
  // 设置水印
  setWaterMark(el, binding.value);
  // 启动监控
  // createObserver(el, binding.value);
};

// 定义指令配置项
const directives = {
  update (el, binding) {
    el.onload = init(el, binding)
  },
};

export default directives
